
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { setProductInfo } from '@/api/product/product'
import { addItem, removeItem } from '@/utils/arrays'
import { strToDateArray, timeJoin } from '@/utils/dateTime'
import { getProductInfo } from '@/api/product/productAccount'

@Component({
  name: 'IndiaH5Extra',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) private product!: any

  private extraParam: any = {
    open_time: [],
    jump_checkout_counter_mode: ''
  }

  private mcList: any = []
  private jumpCheckout: any = ''

  private accountType: any = []
  private openTimes: any[] = [
    [new Date('2021/01/01 00:00'), new Date('2021/01/01 23:59')]
  ]

  // 收银台比率数据展示
  private serverModeList: any = []
  private onData() {
    if (
      !this.product.checkout_counter_rate.server &&
      !this.product.checkout_counter_rate.oss
    ) {
      this.serverModeList = [
        {
          name: 'server',
          rate: '',
          success_volume: '',
          time: '',
          volume: ''
        },
        {
          name: 'oss',
          rate: '',
          success_volume: '',
          time: '',
          volume: ''
        }
      ]
    } else {
      this.serverModeList = [
        {
          name: 'server',
          rate: this.product.checkout_counter_rate.server.rate,
          success_volume:
            this.product.checkout_counter_rate.server.success_volume,
          time: this.product.checkout_counter_rate.server.time,
          volume: this.product.checkout_counter_rate.server.volume
        },
        {
          name: 'oss',
          rate: this.product.checkout_counter_rate.oss.rate,
          success_volume: this.product.checkout_counter_rate.oss.success_volume,
          time: this.product.checkout_counter_rate.oss.time,
          volume: this.product.checkout_counter_rate.oss.volume
        }
      ]
    }
  }

  private addItem = addItem
  private removeItem = removeItem

  private addMc() {
    this.mcList.push('')
  }
  private removeMc(index: number) {
    this.mcList.splice(index, 1)
  }

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private back() {
    this.$emit('close', false)
  }

  private async noExtraUpdate() {
    this.extraParam.open_time = []
    this.openTimes.forEach((time: any) => {
      if (time[0]) {
        const str = timeJoin(time[0], time[1])
        this.extraParam.open_time.push(str)
      }
    })
    // 清空未输入
    this.mcList = this.mcList.filter(item => item !== '')
    this.flag = true
    const data: any = {
      id: this.product.id,
      extra_param: {
        open_time: this.extraParam.open_time,
        mc_list: this.mcList
      }
    }
    await setProductInfo(data).then(() => {
      this.$message({
        message: 'Edit success',
        type: 'success'
      })
      this.flagStr()
      this.back()
    })
  }

  // 跳转收银台模式
  private exists: any = ''
  private async checkoutCounterMode() {
    this.flag = true
    const data: any = {
      id: this.product.id,
      extra_param: {
        jump_checkout_counter_mode: this.jumpCheckout
      }
    }
    await setProductInfo(data).then(() => {
      this.$message({
        message: 'Edit success',
        type: 'success'
      })
      this.flagStr()
      this.back()
    })
  }

  // 产品详情
  private async getInfo() {
    const data = {
      id: this.product.id
    }
    await getProductInfo(data).then((res: any) => {
      if (res) {
        this.extraParam = {
          open_time: res.extra_param.open_time,
          jump_checkout_counter_mode: res.extra_param.jump_checkout_counter_mode
        }
        this.mcList = res.extra_param.mc_list
        this.jumpCheckout = res.extra_param.jump_checkout_counter_mode
      } else {
        this.extraParam = {
          open_time: [],
          jump_checkout_counter_mode: ''
        }
        this.mcList = []
      }
      if (res.extra_param.open_time) {
        this.openTimes = []
        let times: any[] = this.extraParam.open_time
        if (times.length > 0) {
          times.forEach((time: any) => {
            this.openTimes.push(strToDateArray(time))
          })
          this.extraParam = {
            open_time: this.extraParam.open_time
          }
        }
      }
    })
  }

  mounted() {
    this.getInfo()
    this.onData()
  }
}
